import type { DocumentUploadFileMetadata } from './types';

export function describeUploadFile(file: File): DocumentUploadFileMetadata {
  return {
    name: file.name,
    sizeBytes: file.size,
    mimeType: file.type || 'application/octet-stream',
  };
}

export function describeUploadFiles(files: File[]): {
  files: DocumentUploadFileMetadata[];
  fileCount: number;
  totalBytes: number;
} {
  const described = files.map(describeUploadFile);
  return {
    files: described,
    fileCount: described.length,
    totalBytes: described.reduce((sum, file) => sum + file.sizeBytes, 0),
  };
}
